import { render, staticRenderFns } from "./Investigation.vue?vue&type=template&id=46dfdda6&scoped=true&"
import script from "./Investigation.vue?vue&type=script&lang=ts&"
export * from "./Investigation.vue?vue&type=script&lang=ts&"
import style0 from "./Investigation.vue?vue&type=style&index=0&id=46dfdda6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dfdda6",
  null
  
)

export default component.exports